import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./mocks";
import Amplify from "aws-amplify";
import awsExports from "./aws-exports";



import { Provider } from "react-redux";
import store from "./redux/store/index";

Amplify.configure(awsExports);
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
